let appId;
let apiUrl;
let staticUrl;
let fileUrl;
let mapKey;
let sso;
let BaseSSOUrl;
let SSOUrl;
let location_host;
if (process.env.VUE_APP_NODE_ENV == "dev") {
    // apiUrl = "http://172.16.1.26:8090";
    apiUrl = "https://lms-api-trade.ouchn.cn";
    staticUrl = "https://lms-res-static.ouchn.cn/";
    fileUrl = "https://lms-api-trade.ouchn.cn/oss/file/upload";
    mapKey = "VH2BZ-SV5C4-LVUUE-XAQ7X-NZELS-MKB4E";
    sso = "http://testcas.ouchn.cn";

    BaseSSOUrl = 'http://124.196.2.174';
    SSOUrl = '/am/oauth2/authorize?service=initService&response_type=code&client_id=55feb2546d9a4ff1&scope=all&decision=Allow&redirect_uri=';

    location_host = "https://trade-h5.guokai-dev.showcode.fun";
    // window.SITE_CONFIG["LOCATION_HOST"] = "http://127.0.0.1:8001/";
    // window.SITE_CONFIG["LOGIN_HOST"] = "http://testcas.ouchn.cn/lyuapServer";
} else if (process.env.VUE_APP_NODE_ENV == "prod:sit") {
    apiUrl = "https://lms-api-trade.ouchn.cn";
    staticUrl = "https://lms-res-static.ouchn.cn/";
    fileUrl = "https://lms-api-trade.ouchn.cn/oss/file/upload";
    mapKey = "VH2BZ-SV5C4-LVUUE-XAQ7X-NZELS-MKB4E";
    sso = "http://testcas.ouchn.cn";

    BaseSSOUrl = 'http://124.196.2.174';
    SSOUrl = '/am/oauth2/authorize?service=initService&response_type=code&client_id=55feb2546d9a4ff1&scope=all&decision=Allow&redirect_uri=';


    location_host = "https://trade-h5.guokai-dev.showcode.fun";
    // window.SITE_CONFIG["LOCATION_HOST"] = "https://trade-h5.guokai-dev.showcode.fun/";
    // window.SITE_CONFIG["LOGIN_HOST"] = "http://testcas.ouchn.cn/lyuapServer";
} else if (process.env.VUE_APP_NODE_ENV == "prod") {
    apiUrl = "https://lms-api-trade.ouchn.cn";
    staticUrl = "https://lms-res-static.ouchn.cn/";
    fileUrl = "https://lms-api-trade.ouchn.cn/oss/file/upload";
    mapKey = "UDDBZ-BYOOD-RXI4D-HFAEI-TP3HJ-HDFLS";
    sso = "http://tysfrz.pt.ouchn.cn";

    BaseSSOUrl = 'https://iam.pt.ouchn.cn';
    SSOUrl = '/am/oauth2/authorize?service=initService&response_type=code&client_id=72dd0c4e28c24fa0&scope=all&decision=Allow&redirect_uri=';


    location_host = "https://lms-trade-h5.ouchn.cn";
    // window.SITE_CONFIG["LOCATION_HOST"] = "https://lms-trade-h5.ouchn.cn";
    // window.SITE_CONFIG["LOGIN_HOST"] = "http://tysfrz.pt.ouchn.cn/lyuapServer";
} else {
    apiUrl = "https://lms-api-trade.ouchn.cn";
    staticUrl = "https://lms-res-static.ouchn.cn/";
    fileUrl = "https://lms-api-trade.ouchn.cn/oss/file/upload";
    mapKey = "VH2BZ-SV5C4-LVUUE-XAQ7X-NZELS-MKB4E";
    sso = "http://testcas.ouchn.cn";

    BaseSSOUrl = 'http://124.196.2.174';
    SSOUrl = '/am/oauth2/authorize?service=initService&response_type=code&client_id=55feb2546d9a4ff1&scope=all&decision=Allow&redirect_uri=';


    location_host = "https://trade-h5.guokai-dev.showcode.fun";
    // window.SITE_CONFIG["LOCATION_HOST"] = "https://trade-h5.guokai-dev.showcode.fun/";
    // window.SITE_CONFIG["LOGIN_HOST"] = "http://testcas.ouchn.cn/lyuapServer";
}

const apis = {
    // 接口地址
    apiUrl: apiUrl,
    // 文件地址
    fileUrl: fileUrl,
    // 静态资源地址
    staticUrl: staticUrl,
    sso: sso,

    BaseSSOUrl: BaseSSOUrl,
    SSOUrl: SSOUrl,

    location_host: location_host,
    appId: appId,
    // 地图Key
    mapKey: mapKey,
    //导览导航
    guideNavigation: "/api/guide/typeList",
    //导览导航列表
    guideNavigationList: "/api/guide/infoList",
    //服务点详情
    getService: "/api/guide/getDetailById",
    // 判断是否有路线,
    checkPath: "/api/guide/checkPath",
    getPath: "/api/guide/getPath",
    // 手绘地图
    getDrawingMap: "/api/guide/getDrawingMap",
};
export default apis;
